import { lazyImport } from "../../utility/lazyImport";
const { Dashboard } = lazyImport(
  () => import("../../features/dashboard"),
  "Dashboard"
);

const DashboardRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
];

export default DashboardRoutes;
